import { render, staticRenderFns } from "./Zhifu.vue?vue&type=template&id=63f3b5e3&scoped=true"
import script from "./Zhifu.vue?vue&type=script&lang=js"
export * from "./Zhifu.vue?vue&type=script&lang=js"
import style0 from "./Zhifu.vue?vue&type=style&index=0&id=63f3b5e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3b5e3",
  null
  
)

export default component.exports